import { getFristLevel3Group } from '../../api/groupinglist'
import { getGroupList } from '../../api/task'
const GroupingList = {
    state: {
        Grouping: [],
        Grouplist: [],
        customer: '',
    },
    mutations: {
        GET_DEVICELIST(state, data) {
            state.Grouping = data
        },
        GET_GROUPLIST(state, data) {
            state.Grouplist = data
        },
        SET_CUSTOMER(state, data) {
            state.customer = data
        }
    },
    actions: {
        getLevel3Group({ commit }, pid) {
            //触发actions获取所有分组数据
            getFristLevel3Group(pid, this.state.GroupingList.customer)
                .then((res) => {
                    if (res.data.code === 0) {
                        commit('GET_DEVICELIST', res.data.data.list)
                    }
                })
        },
        //获取所有分组列表,并且查询分组下的所有在线设备列表
        getGroupList({ commit }, allDevice) {
            getGroupList(allDevice)
                .then((res) => {
                    if (res.data.code === 0) {
                        commit('GET_GROUPLIST', res.data.data.list)
                    }
                })
        },
        setMonitorGroup({ commit }, data) {
            commit('SET_CUSTOMER', data)
        },
    }
}

export default GroupingList
